import Tooltip from '@mui/material/Tooltip';
import React, { Component } from "react";
import { isMobile } from 'react-device-detect';
import { AppConstatnt } from "../../../../Utils/AppConstant";
import { getTheme } from "../../../../Utils/Utility";
import './tooltip.css';
class LoadStatusNavItem extends Component {

    handleClick = () => {
        const { onItemClick, order } = this.props;
        onItemClick(order);
    }


    render() {
        const { active, badge, name, title, id, className } = this.props;
        const { classes } = this.props;
        const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';

        return (
            <React.Fragment>

                <li className={`nav-item ${className || ''}`} role="presentation" id={id} >
                    <Tooltip title={title} enterTouchDelay={0} arrow>
                        <a style={{ cursor: 'pointer' }} className={active ? "nav-link active loadsIconMobile" : "nav-link loadsIconMobile"} role="tab" onClick={this.handleClick}>
                        <span>{isMobile ? this.props.css : name}</span>
                            <span className="badge badge-light rounded-pill">{badge}</span>
                        </a>
                    </Tooltip>

                </li>
            </React.Fragment>
        );
    }
}
export default LoadStatusNavItem;